<template>
    <div class="MutateTableProfile" v-loading.fullscreen.lock="loading">
        <p class="title">公开表配置</p>
        <el-form label-width="280px">
            <el-form-item label="用户是否可以修改公开表:">
                <el-switch v-model="enabled" active-color="#13ce66" inactive-color="#ff4949" @change='change'>
                </el-switch>
            </el-form-item> 
        </el-form>
    </div>
</template>

<script>
    import {
        getMutateTableProfile,
        postMutateTableProfile
    } from "@/api/zone.js";
    export default {
        name: "MutateTableProfile",
        data() {
            return {
                enabled:false
            };
        },
        mounted() {
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                getMutateTableProfile().then(res=>{
                    if(res.status == 0){
                        this.enabled = res.enabled
                    }
                })
            },
            change(val){
                postMutateTableProfile({
                    enabled:val
                }).then(res=>{
                    if(res.status == 0){
                        this.$message.success('修改成功')
                    }
                })
            }
        },
    };
</script>

<style scoped>
    .configtime /deep/.el-input {
        width: 270px;
    }
    .MutateTableProfile {
        width: 100%;
        padding: 50px;
    }

    /deep/ .el-form-item__label {
        font-size: 20px;
        font-weight: bold;
    }

    .title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 50px;
    }
.center{
    display: flex;
    justify-content: center;
}
</style>
